import React from 'react'
import { useTranslation } from 'react-i18next'
import { ListPagePill, STATUS_PILL } from './ListPageCells'
import './ListPageTable.css'

interface StatusTagProps {
  value: string
}

const StatusTag: React.FC<StatusTagProps> = ({ value }) => {
  const { t } = useTranslation()
  const style = STATUS_PILL[value] ?? {
    bg: '#EAF0F0',
    color: '#5F7484',
  }

  return (
    <ListPagePill
      label={t(value, { defaultValue: value })}
      bg={style.bg}
      color={style.color}
      size="sm"
    />
  )
}

export default StatusTag
